"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugLogHandler = void 0;
var logger_1 = require("./logger");
var registerOnDebugLogs = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!global.abrDebugLogging) {
        global.abrDebugLogging = [];
    }
    global.abrDebugLogging.push(args);
};
exports.debugLogHandler = {
    logLevel: logger_1.LogLevel.Verbose,
    verbose: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return registerOnDebugLogs.apply(void 0, args);
    },
    breadcrumb: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return registerOnDebugLogs.apply(void 0, args);
    },
    info: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return registerOnDebugLogs.apply(void 0, args);
    },
    warn: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return registerOnDebugLogs.apply(void 0, args);
    },
    error: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return registerOnDebugLogs.apply(void 0, args);
    },
};
